// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scheduledId: __t.u64().primaryKey().name("scheduled_id"),
  scheduledAt: __t.scheduleAt().name("scheduled_at"),
  attacker: __t.identity(),
  attackerLife: __t.u32().name("attacker_life"),
  targetKind: __t.string().name("target_kind"),
  targetPlayer: __t.identity().name("target_player"),
  targetId: __t.u64().name("target_id"),
  targetLife: __t.u32().name("target_life"),
  itemKey: __t.string().name("item_key"),
  feedKey: __t.string().name("feed_key"),
  weaponKind: __t.string().name("weapon_kind"),
  reachM: __t.f32().name("reach_m"),
  dmg: __t.i32(),
  control: __t.string(),
  profile: __t.string(),
  contextKind: __t.string().name("context_kind"),
  contextId: __t.u64().name("context_id"),
  contextGen: __t.u32().name("context_gen"),
  startedAt: __t.timestamp().name("started_at"),
  impactAt: __t.timestamp().name("impact_at"),
  hitIntervalMs: __t.u32().name("hit_interval_ms"),
  missIntervalMs: __t.u32().name("miss_interval_ms"),
  worldId: __t.u64().name("world_id"),
});
